import { render, staticRenderFns } from "./PatientAdd.vue?vue&type=template&id=3e92e910&scoped=true"
import script from "./PatientAdd.vue?vue&type=script&lang=js"
export * from "./PatientAdd.vue?vue&type=script&lang=js"
import style0 from "./PatientAdd.vue?vue&type=style&index=0&id=3e92e910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e92e910",
  null
  
)

export default component.exports